import { useQuery } from '@tanstack/react-query'

import { assessmentService } from '@/services/api/assessment.service'
import type { AssessmentCompleto } from '@/types/assessment.types'
import { assessmentQueryKeys } from '@/utils/query/assessments/assessmentQueryClient.utils'
import { defaultQueryOptions, errorUtils } from '@/utils/query/common'

export interface UseAssessmentOptions {
  assessmentId?: string
  expandAll?: boolean
  enabled?: boolean
}

export interface UseAssessmentReturn {
  assessment: AssessmentCompleto | null
  isLoading: boolean
  isError: boolean
  error: string | null
  refetch: () => void
  isFetching: boolean
}

export function useAssessment(options: UseAssessmentOptions = {}): UseAssessmentReturn {
  const { assessmentId, expandAll = false, enabled = true } = options

  const query = useQuery({
    queryKey: assessmentQueryKeys.assessments.detail(assessmentId!),
    queryFn: () => assessmentService.getAssessmentById(assessmentId!, expandAll),
    enabled: enabled && !!assessmentId,
    ...defaultQueryOptions,
    gcTime: 1000 * 60 * 5 // 5 minutes cache time override
  })

  return {
    assessment: query.data ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error ? errorUtils.transformAxiosError(query.error) : null,
    refetch: query.refetch,
    isFetching: query.isFetching
  }
}
